@if (!dataConnectionError && status === 'loaded') {
    <ag-grid-angular
        wdxUtilsAgGridTheme
        [rowData]="rowData"
        [columnDefs]="colDefs"
        [gridOptions]="gridOptions"
        class="w-100"
        data-cy="positions-table"
    >
    </ag-grid-angular>
} @else {
    <wdx-portfolio-not-loaded
        [status]="dataConnectionError ? 'dataConnectionError' : status"
        [connectionErrorMessage]="dataConnectionError?.detail ?? ''"
        [dataTypeLabel]="dataTypeLabel"
    ></wdx-portfolio-not-loaded>
}
